import { render, staticRenderFns } from "./CustomTagInput.vue?vue&type=template&id=3c74ccbf&scoped=true"
import script from "./CustomTagInput.vue?vue&type=script&lang=js"
export * from "./CustomTagInput.vue?vue&type=script&lang=js"
import style0 from "./CustomTagInput.vue?vue&type=style&index=0&id=3c74ccbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c74ccbf",
  null
  
)

export default component.exports